module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Card_JCB-0a6e28413d5e2650052485dae102f0d8.gif";